import ApiService from './ApiService';

import { UserSerializer } from 'services/serializers';

class UserService extends ApiService {
  constructor(session) {
    super(session);

    this.url = '/users';
  }

  checkAccountExists(email) {
    return super.search(`${this.url}/email_taken.json`, { email }, resp => resp);
  }

  get(id) {
    return super.get(`${this.url}/${id}.json`,
      (response) => UserSerializer.deserialize(response));
  }

  getAll(params) {
    return super.search(`${this.url}.json`, params,
      (response) => response.map(item => UserSerializer.deserialize(item)));
  }

  create(user) {
    const payload = { user: UserSerializer.serialize(user) };
    if (user.token) {
      payload['g-recaptcha-response-data'] = {
        'signup_eo': user.token
      }
    }
    return super.post(`${this.url}.json`, payload,
      (response) => UserSerializer.deserialize(response));
  }

  update(user) {
    return super.patch(`${this.url}/${user.id}.json`, { user: UserSerializer.serialize(user) },
      (response) => UserSerializer.deserialize(response))
  }

  delete(user) {
    return super.delete(`${this.url}/${user.id}.json`, () => true);
  }
}

export default UserService;